/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Event_GroupsInputs */

const en_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Groups`)
};

const fr_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupes d'evenements`)
};

const de_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungsgruppen`)
};

const it_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppi di eventi`)
};

const ru_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группы мероприятий`)
};

const es_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

const zh_cn2_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动组`)
};

const ja_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह`)
};

const pt_pt2_ccsl_export_event_groups = /** @type {(inputs: Ccsl_Export_Event_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Event Groups" |
*
* @param {Ccsl_Export_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_event_groups = /** @type {((inputs?: Ccsl_Export_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_event_groups(inputs)
	if (locale === "de") return de_ccsl_export_event_groups(inputs)
	if (locale === "it") return it_ccsl_export_event_groups(inputs)
	if (locale === "ru") return ru_ccsl_export_event_groups(inputs)
	if (locale === "es") return es_ccsl_export_event_groups(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_event_groups(inputs)
	if (locale === "ja") return ja_ccsl_export_event_groups(inputs)
	if (locale === "hi") return hi_ccsl_export_event_groups(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_event_groups(inputs)
	return en_ccsl_export_event_groups(inputs)
});